export type DataTableSticky = 'start' | 'end';

/**
 * Sticky column class for horizontal scroll.
 * `id: 'actions'` remains an end-pin shorthand when `sticky` is omitted.
 */
export function dataTableStickyColumnClass(column: {
    id: string;
    sticky?: DataTableSticky;
}): string | undefined {
    const sticky = column.sticky ?? (column.id === 'actions' ? 'end' : undefined);
    if (sticky === 'start') return 'data-table-col-sticky-start';
    if (sticky === 'end') return 'data-table-col-actions';
    return undefined;
}
